<template>
  <DefButtonPrimary class="order-a-product" @click="handlerBuy">
    <!-- Под заказ -->
    <slot name="onOrder" />
  </DefButtonPrimary>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';

import DefButtonPrimary from '@components/Def/DefButtonPrimary/DefButtonPrimary.vue';
import Analytics from '@/utils/Analytics';

export default {
  name: 'OrderAProduct',
  components: { DefButtonPrimary },
  props: ['result'],
  computed: {
    ...mapState({
      createOrder: ({ basket }) => basket.data?.routes?.createOrder,
    }),
    ...mapGetters({
      inBasket: 'basket/inBasket',
    }),
    id() {
      return this.result?.offer?.id || this.result?.id;
    },
  },
  methods: {
    ...mapActions({
      add: 'basket/add',
    }),
    async handlerBuy() {
      if (!this.inBasket(this.id)) {
        await this.add({ id: this.id });
        Analytics.addToBasket(this.result);
        this.$nextTick(() => {
          window.location.href = this.createOrder.path;
        });
      } else {
        window.location.href = this.createOrder.path;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.order-a-product {
}
</style>
